import { createFileRoute } from "@tanstack/react-router";
import { SeoContentPage } from "@/components/SeoContentPage";
import { husselIndelingenSysteem } from "@/pages/seo-content";

const title = "Hussel indelingen systeem & software voor clubs | De Hussel App";
const description = "Hussel indelingen systeem dat je husselavond automatisch indeelt. Hussel indelingen software voor tennis- en padelclubs: eerlijk, snel en zonder vrijwilligers.";

export const Route = createFileRoute("/hussel-indelingen-systeem")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/hussel-indelingen-systeem" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/hussel-indelingen-systeem" }],
  }),
  component: () => <SeoContentPage data={husselIndelingenSysteem} />,
});
